import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { QuoteDraftItem } from '@/modules/products/types'
import { zustandStorage } from '@/services/storage'

/**
 * Quote draft cart — architecture bridge for Sprint 0.4 (Orçamentos).
 * Products library can push items without implementing quote UI yet.
 */
interface QuoteDraftState {
  items: QuoteDraftItem[]
  addFromProduct: (item: QuoteDraftItem) => void
  removeItem: (productId: string) => void
  clear: () => void
}

export const useQuoteDraftStore = create<QuoteDraftState>()(
  persist(
    (set, get) => ({
      items: [],
      addFromProduct: (item) => {
        const existing = get().items.find((i) => i.productId === item.productId)
        if (existing) {
          set({
            items: get().items.map((i) =>
              i.productId === item.productId
                ? { ...i, quantity: i.quantity + (item.quantity || 1) }
                : i,
            ),
          })
          return
        }
        set({ items: [...get().items, { ...item, quantity: item.quantity || 1 }] })
      },
      removeItem: (productId) =>
        set({ items: get().items.filter((i) => i.productId !== productId) }),
      clear: () => set({ items: [] }),
    }),
    { name: 'masterhub-quote-draft', storage: zustandStorage },
  ),
)
